import React, { Component } from 'react';
import { ActionCreators } from '@redux-devtools/core';
import { Button, Toolbar, Divider } from '@redux-devtools/ui';
import RecordButton from './buttons/RecordButton.js';
import PersistButton from './buttons/PersistButton.js';
import LockButton from './buttons/LockButton.js';
import InstanceSelector from './InstanceSelector.js';
import SyncButton from './buttons/SyncButton.js';
const { reset, rollback, commit, sweep } = ActionCreators;
export default class TopButtons extends Component {
    constructor() {
        super(...arguments);
        this.handleRollback = () => {
            this.props.dispatch(rollback());
        };
        this.handleSweep = () => {
            this.props.dispatch(sweep());
        };
        this.handleCommit = () => {
            this.props.dispatch(commit());
        };
        this.handleReset = () => {
            this.props.dispatch(reset());
        };
    }
    shouldComponentUpdate(nextProps) {
        return (nextProps.options !== this.props.options ||
            nextProps.liftedState !== this.props.liftedState);
    }
    render() {
        const options = this.props.options;
        const features = options.features;
        const { computedStates, skippedActionIds, isPaused, isLocked } = this.props.liftedState;
        const noStates = computedStates.length < 2;
        return (React.createElement(Toolbar, { borderPosition: "bottom" },
            features.pause && React.createElement(RecordButton, { paused: isPaused }),
            features.persist && React.createElement(PersistButton, null),
            features.lock && (React.createElement(LockButton, { locked: isLocked, disabled: options.lib !== 'redux' })),
            React.createElement(Divider, null),
            React.createElement(Button, { title: "Reset to the state you created the store with", tooltipPosition: "bottom", onClick: this.handleReset }, "Reset"),
            React.createElement(Button, { title: "Roll back to the last committed state", tooltipPosition: "bottom", onClick: this.handleRollback, disabled: noStates }, "Revert"),
            React.createElement(Button, { title: "Remove all currently disabled actions from the log", tooltipPosition: "bottom", onClick: this.handleSweep, disabled: skippedActionIds.length === 0 }, "Sweep"),
            React.createElement(Button, { title: "Remove all actions from the log,\\a and make the current state your initial state", tooltipPosition: "bottom", onClick: this.handleCommit, disabled: noStates }, "Commit"),
            React.createElement(Divider, null),
            React.createElement(InstanceSelector, null),
            features.sync && React.createElement(SyncButton, null)));
    }
}
